module.exports = __webpack_public_path__ + "static/media/washington-dc-27.77b480e3.jpg";